const createUrlWithCountryPrefix = ({ url, countryPrefix })=>`${countryPrefix ? `/${countryPrefix}` : ''}${url}`;
const utils_createUrlWithCountryPrefix = createUrlWithCountryPrefix;
export default utils_createUrlWithCountryPrefix;
